<template>
  <!-- 用印信息确认 -->
  <div class="wrap" style="overflow: hidden">
    <yd-navbar title="确认用印" fontsize="16px" style="font-weight: 800;font-family:PingFang SC;color:#000">
      <router-link to="/msoIndex" slot="left">
        <yd-navbar-back-icon></yd-navbar-back-icon>
      </router-link>
    </yd-navbar>
    <yd-preview :buttons="btns">
      <yd-preview-header style="margin-top:10px">
        <div slot="left" style="color:#000;text-align:left;">预约顺序号：{{signInfo.apply_no}}</div>
        <div slot="right">
          <yd-badge shape="square" type="warning">已预约</yd-badge>
        </div>
      </yd-preview-header>
      预约时间：
      <el-tag type="primary" size="mini">{{signInfo.begin_time}}</el-tag>~
      <el-tag type="primary" size="mini">{{signInfo.end_time}}</el-tag>
<!--      <yd-preview-item>-->
<!--        <div slot="left">合同名称</div>-->
<!--        <div slot="right">{{signInfo.contract_name}}</div>-->
<!--      </yd-preview-item>-->
      <yd-preview-item>
        <div slot="left">供应商编码</div>
        <div slot="right">{{signInfo.contract_no_area}}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">供应商名称</div>
        <div slot="right">{{signInfo.supplier_name}}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">地区企业合同号</div>
        <div slot="right">{{signInfo.contract_no_area}}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">签订人名称</div>
        <div slot="right">{{signInfo.contract_no_area}}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">签订时间</div>
        <div slot="right">{{signInfo.apply_date}}</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">备注</div>
        <div slot="right">{{signInfo.apply_date}}</div>
      </yd-preview-item>
    </yd-preview>
    <yd-button size="large" type="primary" shape="circle" @click.native="signEnter">确认用印</yd-button>
  </div>
</template>

<script>
import axios from "axios";
var baseUrl = process.env.API_ROOT;
export default {
  name: "msoSign",
    data(){
        return {
            btns:[],
            code:'',
            signInfo:{},
        }
    },
    mounted(){
        this.code = this.$route.query.code
        this.getInfo(this.code);
    },
    methods:{
        getInfo(code){
            this.$dialog.loading.open('数据加载中……');
          axios({
            method: "get",
            url: baseUrl + "signInfo?code="+code
            }).then(resp => {
                console.log(resp.data.result);
            if(resp.data.result==="true") {
                this.signInfo = resp.data
            }else{
                this.$dialog.toast({ mes: resp.data.message, timeout: 1500 });
                this.$router.push({path:'/msoIndex'})
            }
            })
            this.$dialog.loading.close();
        },
        signEnter(){
            this.$dialog.loading.open('确认用印中……');
           axios({
            method: "post",
            url: baseUrl + "signEnter",
            params:{
                code:this.code,
                signUser:window.localStorage.getItem("checkUserId")
            }
            }).then(resp => {
            if(resp.data.result==="false") {
              this.$dialog.toast({ mes: resp.data.message, timeout: 1500 });
            }else{
                this.$dialog.toast({ mes: resp.data.message, timeout: 1500 });
            }
            })
            this.$dialog.loading.close();
            this.$router.push({path:'/msoIndex'})
        },
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mso-sign.vue